
/*
 *@description: 行情相关
 *@modifyContent:
 *@author: qiuhongyang
 *@date: 2020-07-08 11:19:40
 *
*/

import { toPercent, getColor } from "../utils";
import { getHqDate} from "../apidata";
import dot from 'dot';   
let config = require('../../../config/web');
let tpl = require('./tpl.html');

/**
 * 全球行情
 */
async function loadMarket() {
    try {
        let box = $('#hq_market');
        if (!$('#hq_market').length) {
            return;
        }

        let _url: string = `${config.getWebPath("push2")}api/qt/clist/get?pi=0&pz=10&po=1&np=1&fields=f1,f2,f3,f4,f12,f13,f14&fltt=2&invt=2&ut=13697a1cc677c8bfa9a496437bfef419&fs=i:1.000001,i:0.399001,i:0.399006,i:100.HSI,i:100.DJIA`
        let json = await getHqDate(_url)
        if (!(json && json.data && json.data.diff)) {
            return;
        }
        let data = json.data.diff;
        let res = data.map((item: any) => {
            return {
                url: `http://quote.eastmoney.com/unify/r/${item.f13}.${item.f12}`,
                name: item.f14,
                close: item.f2,
                zdf: toPercent(item.f3),
                textColor: getColor(item.f4),
                iconColor: getColor(item.f4, ['icon_up', 'icon_down', ''])
            };

        })
        let html = dot.template(tpl)(res);
        $('#hq_market').html(html);
    } catch (error) {}
}


export default loadMarket;